// extracted by mini-css-extract-plugin
module.exports = {"container":"ui","list":"vi"};